import { NewPortfolioController } from './newPortfolio.controller';
import template from './newPortfolio.html';

export const newPortfolioComponent = {
  name: 'newPortfolioComponent',
  restrict: 'E',
  template,
  controller: NewPortfolioController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/app/components/newPortfolio/newPortfolio.component.js